import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { exportProgramWiseACDPDFReport } from "actions";

const DownloadPDF = ({extraFiltersState}) => {

  const dispatch = useDispatch();
  const session = useSelector((s) => s.session);
  const object_viewed_id = session?.current_page_permissions?.object_id || "";

  const downloadZip = () => {
    let month = extraFiltersState.values.month;
    let year = extraFiltersState.values.year;
    dispatch(exportProgramWiseACDPDFReport({ month, year, object_viewed_id }));
  };

  return (
    <>
      <div>
        <button
          className="c-b-btn"
          onClick={downloadZip}
        >
          <img src="/assets/images/pdf-icon.svg" alt="" className="me-2" />
          Download PDF
        </button>

      </div>
    </>
  );
};

export default DownloadPDF;
